import React, { useEffect, useState } from "react";
import { supabase } from "../../../../supabaseClient.jsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Quote } from "lucide-react";
import { Card, Avatar } from "../../../../design-system/index.js";
import { cn } from "../../../../design-system/index.js";

import "swiper/css";
import "swiper/css/pagination";

const depoimentosIniciais = [
  {
    id: "manual-1",
    depoimento:
      'Muito importante saber que nossos "tesourinhos" estão sendo cuidados com carinho, atenção e, principalmente com uma pessoa de confiança como a Caca, instruída.',
    autor_nome: "Maria Marins",
    nota: 5,
    foto_url: null,
  },
  {
    id: "manual-2",
    depoimento: "Você é um sonho, obrigada pelo carinho com o Augusto!",
    autor_nome: "Rebeka",
    nota: 5,
    foto_url: null,
  },
];

const getPublicUrl = (path) => {
  if (!path || path.startsWith("http")) return path || "/assets/logo-tesourinhos-trans.png";
  const cleanPath = path.replace(/^(foto-perfil\/|fotos-perfil\/)/, "");
  const { data } = supabase.storage.from("fotos-perfil").getPublicUrl(cleanPath);
  return data?.publicUrl || "/assets/logo-tesourinhos-trans.png";
};

const initials = (name) =>
  (name || "?")
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();

export default function TestimonialsSection() {
  const [depoimentos, setDepoimentos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function carregarDepoimentos() {
      const { data, error } = await supabase
        .from("vw_depoimentos_publicos")
        .select("*")
        .order("created_at", { ascending: false });

      setDepoimentos(
        !error && data ? [...depoimentosIniciais, ...data] : depoimentosIniciais,
      );
      setLoading(false);
    }
    carregarDepoimentos();
  }, []);

  if (loading) return null;

  return (
    <section
      id="depoimentos"
      className="bg-gradient-to-b from-white to-[var(--color-warm-50)] py-16 sm:py-20"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className={cn(
            "font-heading text-3xl sm:text-4xl font-bold",
            "text-[var(--color-warm-900)]"
          )}>
            Mães que Confiam e Recomendam
          </h2>
          <p className={cn(
            "mt-3 text-[var(--color-warm-500)] text-sm sm:text-base",
            "max-w-sm mx-auto"
          )}>
            Histórias reais de famílias que encontraram a babá perfeita.
          </p>
        </div>

        <Swiper
          key={depoimentos.length}
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          speed={800}
          pagination={{ clickable: true }}
          loop={depoimentos.length >= 6}
          spaceBetween={20}
          observer
          observeParents
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="pb-8"
        >
          {depoimentos.map((d) => (
            <SwiperSlide key={d.id}>
              <Card className="h-full rounded-2xl p-6 flex flex-col">
                {/* Estrelas */}
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <span
                      key={i}
                      className={cn(
                        "text-base",
                        i < (d.nota || 0) ? "text-amber-400" : "text-[var(--color-warm-200)]"
                      )}
                    >
                      ★
                    </span>
                  ))}
                </div>

                {/* Aspas */}
                <Quote size={18} className="text-[var(--color-rose-400)/40] mb-2" />

                {/* Texto */}
                <p className="flex-1 text-sm text-[var(--color-warm-700)] leading-relaxed italic">
                  {d.depoimento}
                </p>

                {/* Autor */}
                <div className="flex items-center gap-3 mt-5 pt-4 border-t border-[var(--color-warm-100)]">
                  {d.foto_url ? (
                    <Avatar
                      src={getPublicUrl(d.foto_url)}
                      alt={d.autor_nome}
                      className="h-9 w-9"
                    />
                  ) : (
                    <Avatar className="h-9 w-9 bg-[var(--color-rose-400)/15] text-[var(--color-rose-400)]">
                      {initials(d.autor_nome)}
                    </Avatar>
                  )}
                  <p className="text-sm font-semibold text-[var(--color-warm-800)]">
                    {d.autor_nome}
                  </p>
                </div>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}